/* Add read Only and required columns Feb 1, 2025 */
/* GUI changes Phase 1 May 15, 2026 */
<template lang="pug">
	div(class="container kt-multiSelect input " ref="input"   )
		b-form-tags(class="styled-input" style="height:30px;" v-model="d_value" :disabled="p_readOnly" tag-pills tag-variant="primary" separator="," placeholder="" remove-on-delete @remove="m_removeTag(tag)")
		b-form-select(class="styled-input" style="height:31px;" v-model="d_selectValue" :required="p_required" :disabled="p_readOnly" :options="c_options"  @change="m_selectChange")
</template>
<script> 
	export default {
	name: "kt-custom-multiselect",
	created() {},
	mounted(){},
	data() {
		return {
			d_value: [],
			d_selectValue:null,
      }
    },
	props: {
		p_options:Array,
		p_value:Array,
		p_readOnly: Boolean,
		p_required: {type: Boolean, default: false},
	},
    computed: {
      c_options() {
        return this.p_options.filter(opt => this.d_value.indexOf(opt) === -1);
      },
	  c_value(){return this.d_value;},
		
	},
	methods:{
		m_selectChange(e){this.d_value.push(e);},
		m_removeTag(tag){this.d_value.spice(this.d_value.indexOf(tag),1);},
		m_tagsChanged(value){this.d_value=[...value];},
		
	},
	watch: {
	p_value(nv,ov){
		this.d_value=nv instanceof Array?nv:new Array(nv);
	},
	d_value(nv){this.$emit('input',nv);}
	}
  }
</script>
<style scoped lang="less">
.container {position: relative;
            display: flex;
            flex-direction: column;
            width: 530px; /* Adjust the width as needed */
 }
 .input-field {
            top: 0px; /* Space between input and select */
			width: 510px;
			//border-right:0px;
			z-index: 1;
 }
.select-field {
			position:absolute;
			top: 0px;
			width: 530px; /* Make the select a bit longer */
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;
  box-shadow: none;
}
</style>